export function logTone(value) {
  const log = String(value || '').trim().toLowerCase();
  if (!log || log.includes('click received')) return 'pending';
  if (log === '200') return 'pass';
  return 'block';
}

export function logLabel(value) {
  const tone = logTone(value);
  if (tone === 'pending') return 'processing';
  if (tone === 'pass') return 'passed';
  return String(value).replace(/,\s*return status \d+\s*$/i, '').trim();
}
